<script>
	export let label = "label";
	export let id = "";
	export let val = 0;

	let invalid = false;
	let message = "";

	function validate(e) {
		let negRx = /^(\-)+[0-9]*$/;
		invalid = negRx.test(e.target.value);

		if (invalid) {
			val = "";
			message = "Positive whole numbers only";
		}
	}
</script>

<label for={id}>
  {label}
</label>
<input type="number" min="0" id={id} bind:value={val} on:input={validate} class:error={invalid} on:focus on:blur>

{#if invalid}
	<p class="validate">
		{message}
	</p>
{/if}

<style>
	.validate {
		margin: 0.25rem 0;
		font-size: 0.875rem;
		color: #c33;
	}

	.error {
		border-color: #c33;
	}
</style>
